import React from "react";
import { Link } from "react-router-dom";

const NavFooter = () => {
  return (
    <>
      <ul className="footerNav">
        <li className={window.location.pathname== "/employee" || window.location.pathname == "/packages" || window.location.pathname == "/promos" ? "active":"" }>
          <Link to="/employee">
            {/* <MaterialIcon icon="settings" color={colorPalette.grey._70} /> */}
            <i className="material-symbols-rounded mt-m white">settings</i>
            Settings
          </Link>
        </li>
      </ul>
    </>
  );
};

export default NavFooter;
